export const USER_TYPE = {
  MMUHEAD: "MMU Head",
  ADMIN: "Admin",
  MMUSTAFF: "MMU Staff",
  HOSPITALADMIN: "Admin",
  DOCTOR: "Doctor",
  ASSISTANT: "Staff",
  MARKETING_USER: "Marketing User",
  DOCTOR_INFO_MANAGEMENT_USER: "Doctor Information Management User",
};

export const FORMAT_VISIT_TAGS = {
  CONSULTATION: "Consultation",
  FOLLOWUP: "Follow-up",
  EMERGENCY: "Emergency",
  FIRSTVISIT: "First Visit",
  TREATMENTPLANNING: "Treatment Planning",
  POSTOPCHECKUP: "Post-Op Checkup",
  REFERRAL: "Referral",
};

export const REVERSE_FORMAT_VISIT_TAGS = {
  'Consultation': "CONSULTATION",
  'Follow-up': "FOLLOWUP",
  'Emergency': "EMERGENCY",
  'First Visit': "FIRSTVISIT",
  'Treatment Planning': "TREATMENTPLANNING",
  'Post-Op Checkup': "POSTOPCHECKUP",
  'Referral': "REFERRAL",
};